import { render, staticRenderFns } from "./PublishDisplay.vue?vue&type=template&id=19573d3d&scoped=true&"
import script from "./PublishDisplay.vue?vue&type=script&lang=js&"
export * from "./PublishDisplay.vue?vue&type=script&lang=js&"
import style0 from "./PublishDisplay.vue?vue&type=style&index=0&id=19573d3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19573d3d",
  null
  
)

export default component.exports